import React from "react";
import { useSelector } from "react-redux";

const TabsComponent = ({ tabs, selectedTab, onSelectTab }) => {
     const homescreenprev = useSelector((state) => state.userPrivileges.homescreen);

  // Filter out the 'Intake' tab if the privilege is missing
  const filteredTabs = homescreenprev.includes('Intake')
    ? tabs
    : tabs.filter(tab => tab.label !== 'Intake');

  return (
    <div className="w-full h-[34px]  flex-shrink-0 relative">
      {filteredTabs?.map((tab, index) => (
        <div
          key={index}
          onClick={() => onSelectTab(index)}
          className={`font-inter w-[48px] tracking-[0] text-lg absolute font-medium whitespace-nowrap leading-5 pb-2 cursor-pointer ${
            selectedTab === index ? "text-[#E17954] border-b-4 border-[#E17954]" : "text-[#0B1C33]"
          }`}
          style={{ left: `${5 + index * 75}px`,fontSize:'15px' }}
        >
          {tab.label}
        </div>
      ))}
      
      {/* <div
        className={`top-[20px] h-[6px] rounded-sm bg-[#e17954] absolute`}
        style={{
          left: `${2 + selectedTab * 75}px`,
          width: `${tabs[selectedTab].width}px`,
        }}
      /> */}
      
    </div>
  );
};

export default TabsComponent;
